import DOMPurify from 'dompurify';
import { withAnonymousSvgImages } from './svgImageCorsHelpers';

/**
 * Clean an ad variant's stored SVG before it is put into the page as markup.
 *
 * SYM-6516. The rail shows `variant.svg` with dangerouslySetInnerHTML. That string is either
 * Fabric's canvas.toSVG() or whatever was saved through the API, and the API returns it as stored.
 * Fabric 5.5.2 does not escape gradient colours or some text attributes in toSVG()
 * (GHSA-hfvx-25r5-qc3w, GHSA-w22m-hvvm-xmwx), so a saved design can turn into an event handler in
 * a colleague's browser. DOMPurify's SVG profile keeps shapes, text, gradients and image links
 * and drops scripts, event handlers and javascript: links.
 *
 * Images get crossorigin="anonymous" AFTER cleaning, because DOMPurify does not keep that
 * attribute (see withAnonymousSvgImages for why it matters).
 */
export const cleanInlineSvg = (svg: string): string =>
  withAnonymousSvgImages(
    DOMPurify.sanitize(svg, { USE_PROFILES: { svg: true, svgFilters: true } })
  );
